import React from 'react';
import styled from 'styled-components';
import {
  formatClearstreamSyncSummary,
  useClearstreamSyncMeta,
  useSyncClearstream,
} from '../hooks/useClearstreamSync';
import { SecondaryButton } from '../styles/marketingSharedStyles';

const Cluster = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

const LastSync = styled.span`
  font-size: 0.8rem;
  color: var(--onSurfaceVariant);
  white-space: nowrap;
`;

const formatDateTime = (value?: string | null) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

export const SyncClearstreamButton: React.FC = () => {
  const { data: syncMeta } = useClearstreamSyncMeta('marketing');
  const { mutateAsync: sync, isPending } = useSyncClearstream('marketing');

  const handleSync = async () => {
    try {
      const result = await sync();
      window.alert(formatClearstreamSyncSummary(result));
    } catch (err) {
      console.error('[SyncClearstream] marketing sync failed', err);
      const message = err instanceof Error ? err.message : 'Unknown error';
      window.alert(`Sync failed: ${message}. Check function logs (sync-clearstream).`);
    }
  };

  return (
    <Cluster>
      {syncMeta?.last_synced_at ? (
        <LastSync>Last sync: {formatDateTime(syncMeta.last_synced_at)}</LastSync>
      ) : null}
      <SecondaryButton type="button" onClick={handleSync} disabled={isPending}>
        {isPending ? 'Syncing...' : 'Sync from Clearstream'}
      </SecondaryButton>
    </Cluster>
  );
};

export default SyncClearstreamButton;
